// 4-week (28-day) billing period helpers, shared so every page agrees on which cycle
// is "current". The Controls sheet's reportEndDate only supplies the ALIGNMENT (which
// Saturday the 28-day grid lands on); the CURRENT period is always derived from today,
// so the engine auto-recognises the live period without a manual Controls update.

// Given any date and a period-end anchor (both ISO yyyy-mm-dd), return the ISO end date
// of the 28-day cycle that CONTAINS that date. anchor + ceil((date-anchor)/28)*28.
// e.g. detectPeriodEnd('2026-06-21','2026-05-16') -> '2026-07-11'.
export function detectPeriodEnd(dateISO, anchorISO) {
  const anchor = new Date(anchorISO + 'T00:00:00');
  const date   = new Date(dateISO + 'T00:00:00');
  if (isNaN(anchor.getTime()) || isNaN(date.getTime())) return anchorISO;
  const diffDays = Math.round((date - anchor) / 86400000);
  const periods  = Math.ceil(diffDays / 28);
  const end = new Date(anchor);
  end.setDate(anchor.getDate() + periods * 28);
  return `${end.getFullYear()}-${String(end.getMonth() + 1).padStart(2, '0')}-${String(end.getDate()).padStart(2, '0')}`;
}

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

// The Saturday the 28-day grid lands on. Same value DriverReviewPage's activation picker
// uses — anything dated against the RCTI must sit on this grid, or it keys a period that
// buildRCTI never asks for and the change silently does nothing.
export const PERIOD_ANCHOR_END = '2026-05-16';

const addDays = (iso, n) => {
  const [y, m, dd] = iso.split('-').map(Number);
  const d = new Date(y, m - 1, dd + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
};

// Selectable periods on the 28-day grid, newest first, each as {startISO, endISO, label}.
// `current` marks the period containing today — the sensible default for a change that
// takes effect from now.
export function periodGrid({ back = 6, forward = 3, anchorEnd = PERIOD_ANCHOR_END } = {}) {
  const fmt = (iso) => {
    const [y, m, dd] = iso.split('-').map(Number);
    return new Date(y, m - 1, dd).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });
  };
  // Walk out from the CURRENT period, not the anchor — the anchor is only the grid
  // alignment, and counting from it would slide the window out of usefulness as the
  // anchor recedes into the past.
  const currentEnd = detectPeriodEnd(todayISO(), anchorEnd);
  const out = [];
  for (let i = -back; i <= forward; i++) {
    const endISO = addDays(currentEnd, i * 28);
    const startISO = addDays(endISO, -27);
    out.push({ startISO, endISO, label: `${fmt(startISO)} to ${fmt(endISO)}`, current: i === 0 });
  }
  return out.reverse();
}
